import { render, staticRenderFns } from "./TouchpointStatisticsOther.vue?vue&type=template&id=5b1dbda7&scoped=true&"
import script from "./TouchpointStatisticsOther.vue?vue&type=script&lang=js&"
export * from "./TouchpointStatisticsOther.vue?vue&type=script&lang=js&"
import style0 from "./TouchpointStatisticsOther.vue?vue&type=style&index=0&id=5b1dbda7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1dbda7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b1dbda7')) {
      api.createRecord('5b1dbda7', component.options)
    } else {
      api.reload('5b1dbda7', component.options)
    }
    module.hot.accept("./TouchpointStatisticsOther.vue?vue&type=template&id=5b1dbda7&scoped=true&", function () {
      api.rerender('5b1dbda7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/TouchpointOverview/Statistics/TouchpointStatisticsOther.vue"
export default component.exports